import { atom } from "jotai";

// Global atom to control spinner visibility
export const spinnerAtom = atom(false);
